import L, { LatLng, Circle, Map} from "leaflet";

export const checkIncluding = (point: LatLng, existingPoints: Array<{position: LatLng}>) => {
    for (let key in existingPoints) {
        if (existingPoints[key].position.distanceTo(point) < 2000) {
            return true
        }
    } return false;
};